import { render, staticRenderFns } from "./SeguidoresDialog.vue?vue&type=template&id=2079845a&scoped=true"
import script from "./SeguidoresDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./SeguidoresDialog.vue?vue&type=script&setup=true&lang=js"
import style0 from "./SeguidoresDialog.vue?vue&type=style&index=0&id=2079845a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2079845a",
  null
  
)

export default component.exports